export default {
  pt: {
    "surname": "sobrenome",
    "your title": "título profissional",
    "current country": "país atual",
    "city": "cidade",
    "curriculum details could not be updated": "não foi possível atualizar os dados deste currículo. Seus dados foram mantidos; tente novamente",
    "curriculum details updated": "dados deste currículo atualizados",
    "link type": "tipo de link",
    "select an option": "selecione uma opção",
    "external": "externo",
    "use a secure https link": "use um link HTTPS seguro",
    "edit link": "editar link",
    "delete link": "excluir link",
    "opens in a new tab": "abre em uma nova aba",
    "select a link type and enter a valid https link": "selecione o tipo e informe um link HTTPS válido",
    "professional link could not be saved": "não foi possível salvar o link. Seus dados foram mantidos; tente novamente",
    "professional link could not be deleted": "não foi possível excluir o link. Tente novamente",
    "do you really want to delete this link": "deseja realmente excluir este link",
    "project title": "título do projeto",
    "project link": "link do projeto",
    "media link": "link da mídia",
    "use an https image or video link": "use um link HTTPS de imagem ou vídeo",
    "display order": "ordem de exibição",
    "edit project": "editar projeto",
    "delete project": "excluir projeto",
    "enter a title and valid https links": "informe um título e links HTTPS válidos",
    "portfolio project could not be saved": "não foi possível salvar o projeto. Seus dados foram mantidos; tente novamente",
    "portfolio project could not be deleted": "não foi possível excluir o projeto. Tente novamente",
    "do you really want to delete this project": "deseja realmente excluir este projeto",
    'presentation text': 'texto de apresentação',
    'write about your experiences, your industry or your skills. also talk about your previous jobs': 'escreva sobre suas experiências, sua área ou suas habilidades. Conte também sobre seus trabalhos anteriores',
    'changes are saved automatically': 'as alterações são salvas automaticamente',
    'saving automatically': 'salvando automaticamente',
    'changes not saved yet': 'alterações ainda não salvas',
    'changes saved automatically': 'alterações salvas automaticamente',
    'automatic save failed; use the save button': 'não foi possível salvar automaticamente; use o botão Salvar',
    'there was an error adding your presentation': 'não foi possível salvar a apresentação. Seu texto foi mantido; tente novamente',
    'your presentation was added': 'apresentação salva',
    'language proof': 'comprovante do idioma', optional: 'opcional',
    idiom: 'idioma', speaking: 'fala', listening: 'compreensão oral', writing: 'escrita', reading: 'leitura',
    'add idiom': 'adicionar idioma', 'edit idiom': 'editar idioma', 'update idiom': 'atualizar idioma',
    'add skill': 'adicionar habilidade', 'edit skill': 'editar habilidade', 'update skill': 'atualizar habilidade',
    'add presentation': 'adicionar apresentação', 'edit presentation': 'editar apresentação', 'update presentation': 'atualizar apresentação',
    'close': 'fechar',
    "curriculum editor": "editor de currículo",
    "preview curriculum": "visualizar currículo",
    "curriculum preview": "prévia do currículo",
    "visual template": "modelo visual",
    "classic template": "clássico",
    "modern template": "moderno",
    "minimal template": "minimalista",
    "modelo europeu": "modelo europeu",
    "generating pdf": "gerando PDF…",
    "export pdf": "exportar PDF",
    "back to editor": "voltar ao editor",
    "pdf could not be generated": "não foi possível gerar o PDF. Tente novamente",
    "curriculum could not be loaded": "não foi possível carregar o currículo",
    "loading curriculum": "carregando currículo",
    "no information added yet": "nenhuma informação adicionada ainda",
    "finish review": "concluir revisão",
    "this curriculum version is used in an application and is read only; duplicate it to make changes": "esta versão do currículo foi usada em uma candidatura e é somente leitura; duplique-a para fazer alterações",
    "no idioms": "nenhum idioma adicionado",
    "no presentation": "sem apresentação",
    "professional experiences": "experiências profissionais",
    "professional skills": "habilidades profissionais",
    "complete professional curriculum": "currículo profissional completo",
    "current": "atual",
    "open media": "abrir mídia",
    "curriculum": "currículo",
    'could not load education options': 'não foi possível carregar as opções de formação',
    'network navigation': 'rede',
    'certification duration': 'carga horária',
    'open project': 'abrir projeto',
    'issue date': 'data de emissão',
    'public profile uses the sections you chose to publish': 'o perfil público usa as seções que você escolheu publicar. Alterações posteriores no currículo não são publicadas automaticamente',
    'update published profile sections': 'atualizar seções do perfil público',
    'course title': 'título do curso', 'education level': 'nível de formação',
    'enter a skill name': 'informe o nome da habilidade',
    'skill name must have at least 2 characters': 'o nome da habilidade deve ter pelo menos 2 caracteres',
    'skill name must have at most 150 characters': 'o nome da habilidade deve ter no máximo 150 caracteres',
    'complete the required curriculum fields': 'informe o nome, o idioma e o arquivo do currículo',
    'import an existing curriculum': 'importar currículo existente', 'import as draft': 'importar como rascunho',
    'pdf, docx or txt creates a private draft for your review': 'PDF, DOCX ou TXT cria um rascunho privado para sua revisão',
    'imported pdfs': 'PDFs importados', 'editor curricula': 'currículos criados no editor',
    'curriculum file': 'arquivo do currículo', 'choose a file': 'selecionar arquivo', 'no file selected': 'nenhum arquivo selecionado',
    'pdf import limit reached': 'você já tem 3 PDFs importados. O limite inicial é de 3 PDFs',
    'curriculum import failed': 'não foi possível importar. Seus dados foram mantidos; confira o arquivo e tente novamente',
    'curriculum imported as draft': 'currículo importado como rascunho. Revise antes de concluir',
    'curriculum file must be at most 5 mb': 'o arquivo deve ter no máximo 5 MB',
    'supported curriculum formats are pdf, docx and txt': 'os formatos aceitos são PDF, DOCX e TXT',
    'curriculum file could not be read': 'não foi possível ler o arquivo. Use um PDF com texto selecionável, DOCX ou TXT de até 5 MB',
    'curriculum name': 'nome do currículo', 'version': 'versão', 'type': 'tipo', 'status': 'estado', 'actions': 'ações', 'name': 'nome',
    'complete review': 'concluir revisão', 'duplicate': 'duplicar', 'view': 'visualizar', 'edit': 'editar',
    'failed to load curricula': 'não foi possível carregar seus currículos. Tente novamente',
    beginner: 'iniciante', 'advanced beginner': 'iniciante avançado', intermediate: 'intermediário', advanced: 'avançado', expert: 'especialista',
    'copy sections from a curriculum': 'copiar seções de um currículo', 'keep current profile sections': 'manter seções atuais do perfil', 'copied sections stay independent of later curriculum changes': 'as seções copiadas ficam independentes das alterações futuras no currículo',
    'active curricula': 'currículos ativos', 'compare plans': 'comparar planos',
    presentation: 'apresentação', languages: 'idiomas', skills: 'habilidades', experience: 'experiência', education: 'formação', certifications: 'certificações', portfolio: 'portfólio',
    'professional references': 'referências profissionais', 'professional links': 'links profissionais',
    'add your professional networks and external links': 'adicione suas redes profissionais e links externos',
    'showcase projects, work links and media': 'apresente projetos, trabalhos e mídias',
    'no professional link added yet': 'nenhum link profissional adicionado', 'no portfolio project added yet': 'nenhum projeto adicionado',
    'no certifications': 'nenhuma certificação adicionada', 'no skills': 'nenhuma habilidade adicionada',
    'profile languages': 'idiomas do perfil', 'profile language': 'idioma do perfil', primary: 'principal',
    'translate your public profile independently of your curricula': 'crie versões do seu perfil público em outros idiomas. Cada currículo tem seu próprio conteúdo',
    'professional title': 'título profissional', 'use as primary profile language': 'usar como idioma principal do perfil',
    'profile language saved': 'versão do perfil salva', 'could not save profile language': 'não foi possível salvar a versão do perfil',
    'edit curriculum details': 'editar dados deste currículo', 'include photo in curriculum': 'incluir foto no currículo',
    'customize this curriculum independently of your public profile': 'personalize este currículo de forma independente do seu perfil público',
    'my curricula': 'meus currículos', 'duplicate curriculum': 'duplicar currículo', 'name the new curriculum': 'nome do novo currículo', copy: 'cópia',
    'create a new curriculum': 'criar novo currículo', 'create curriculum': 'criar currículo', 'curriculum language': 'idioma do currículo',
    'pending review': 'aguardando revisão', 'new skill will be suggested for review and saved in your curriculum': 'esta habilidade será salva no seu currículo e sugerida para revisão do catálogo',
    'choose a catalog skill or suggest a new one': 'escolha uma habilidade do catálogo ou sugira uma nova',
    'skill suggestion rejected; choose another skill': 'sugestão não aprovada; escolha outra habilidade',
    'add link': 'adicionar link', 'add project': 'adicionar projeto', 'ready': 'pronto',
  },
  es: {
    "surname": "apellidos",
    "your title": "título profesional",
    "current country": "país actual",
    "city": "ciudad",
    "curriculum details could not be updated": "no se pudieron actualizar los datos de este currículum. Tus datos se han conservado; inténtalo de nuevo",
    "curriculum details updated": "datos de este currículum actualizados",
    "link type": "tipo de enlace",
    "select an option": "selecciona una opción",
    "external": "externo",
    "use a secure https link": "usa un enlace HTTPS seguro",
    "edit link": "editar enlace",
    "delete link": "eliminar enlace",
    "opens in a new tab": "se abre en una pestaña nueva",
    "select a link type and enter a valid https link": "selecciona el tipo e introduce un enlace HTTPS válido",
    "professional link could not be saved": "no se pudo guardar el enlace. Tus datos se han conservado; inténtalo de nuevo",
    "professional link could not be deleted": "no se pudo eliminar el enlace. Inténtalo de nuevo",
    "do you really want to delete this link": "¿quieres eliminar este enlace",
    "project title": "título del proyecto",
    "project link": "enlace del proyecto",
    "media link": "enlace multimedia",
    "use an https image or video link": "usa un enlace HTTPS de imagen o vídeo",
    "display order": "orden de visualización",
    "edit project": "editar proyecto",
    "delete project": "eliminar proyecto",
    "enter a title and valid https links": "introduce un título y enlaces HTTPS válidos",
    "portfolio project could not be saved": "no se pudo guardar el proyecto. Tus datos se han conservado; inténtalo de nuevo",
    "portfolio project could not be deleted": "no se pudo eliminar el proyecto. Inténtalo de nuevo",
    "do you really want to delete this project": "¿quieres eliminar este proyecto",
    'presentation text': 'texto de presentación',
    'write about your experiences, your industry or your skills. also talk about your previous jobs': 'escribe sobre tu experiencia, tu sector o tus habilidades. Cuenta también tus trabajos anteriores',
    'changes are saved automatically': 'los cambios se guardan automáticamente',
    'saving automatically': 'guardando automáticamente',
    'changes not saved yet': 'cambios aún sin guardar',
    'changes saved automatically': 'cambios guardados automáticamente',
    'automatic save failed; use the save button': 'no se pudo guardar automáticamente; usa el botón Guardar',
    'there was an error adding your presentation': 'no se pudo guardar la presentación. Tu texto se ha conservado; inténtalo de nuevo',
    'your presentation was added': 'presentación guardada',
    'language proof': 'acreditación del idioma', optional: 'opcional',
    idiom: 'idioma', speaking: 'expresión oral', listening: 'comprensión oral', writing: 'escritura', reading: 'lectura',
    'add idiom': 'añadir idioma', 'edit idiom': 'editar idioma', 'update idiom': 'actualizar idioma',
    'add skill': 'añadir habilidad', 'edit skill': 'editar habilidad', 'update skill': 'actualizar habilidad',
    'add presentation': 'añadir presentación', 'edit presentation': 'editar presentación', 'update presentation': 'actualizar presentación',
    'close': 'cerrar',
    "curriculum editor": "editor de currículum",
    "preview curriculum": "vista previa del currículum",
    "curriculum preview": "vista previa del currículum",
    "visual template": "modelo visual",
    "classic template": "clásico",
    "modern template": "moderno",
    "minimal template": "minimalista",
    "modelo europeu": "modelo europeo",
    "generating pdf": "generando PDF…",
    "export pdf": "exportar PDF",
    "back to editor": "volver al editor",
    "pdf could not be generated": "no se pudo generar el PDF. Vuelve a intentarlo",
    "curriculum could not be loaded": "no se pudo cargar el currículum",
    "loading curriculum": "cargando currículum",
    "no information added yet": "aún no se ha añadido información",
    "finish review": "finalizar revisión",
    "this curriculum version is used in an application and is read only; duplicate it to make changes": "esta versión del currículum se ha usado en una candidatura y es de solo lectura; duplícala para realizar cambios",
    "no idioms": "ningún idioma añadido",
    "no presentation": "sin presentación",
    "professional experiences": "experiencia profesional",
    "professional skills": "habilidades profesionales",
    "complete professional curriculum": "currículum profesional completo",
    "current": "actual",
    "open media": "abrir contenido multimedia",
    "curriculum": "currículum",
    'try again': 'intentar de nuevo',
    'could not load education options': 'no se pudieron cargar las opciones de formación',
    'network navigation': 'red',
    'certification duration': 'duración',
    'open project': 'abrir proyecto',
    'issue date': 'fecha de emisión',
    'public profile uses the sections you chose to publish': 'el perfil público utiliza las secciones que elegiste publicar. Los cambios posteriores del currículum no se publican automáticamente',
    'update published profile sections': 'actualizar secciones del perfil público',
    'course title': 'título del curso', 'education level': 'nivel de formación',
    'enter a skill name': 'indica el nombre de la habilidad',
    'skill name must have at least 2 characters': 'el nombre de la habilidad debe tener al menos 2 caracteres',
    'skill name must have at most 150 characters': 'el nombre de la habilidad debe tener como máximo 150 caracteres',
    'complete the required curriculum fields': 'indica el nombre, el idioma y el archivo del currículum',
    'import an existing curriculum': 'importar un currículum existente', 'import as draft': 'importar como borrador',
    'pdf, docx or txt creates a private draft for your review': 'PDF, DOCX o TXT crea un borrador privado para que lo revises',
    'imported pdfs': 'PDF importados', 'editor curricula': 'currículums creados en el editor',
    'curriculum file': 'archivo del currículum', 'choose a file': 'seleccionar archivo', 'no file selected': 'ningún archivo seleccionado',
    'pdf import limit reached': 'ya tienes 3 PDF importados. El límite inicial es de 3 PDF',
    'curriculum import failed': 'no se pudo importar. Tus datos se han conservado; revisa el archivo y vuelve a intentarlo',
    'curriculum imported as draft': 'currículum importado como borrador. Revísalo antes de terminar',
    'curriculum file must be at most 5 mb': 'el archivo debe tener un máximo de 5 MB',
    'supported curriculum formats are pdf, docx and txt': 'los formatos admitidos son PDF, DOCX y TXT',
    'curriculum file could not be read': 'no se pudo leer el archivo. Usa un PDF con texto seleccionable, DOCX o TXT de hasta 5 MB',
    'curriculum name': 'nombre del currículum', 'version': 'versión', 'type': 'tipo', 'status': 'estado', 'actions': 'acciones', 'name': 'nombre',
    'complete review': 'completar revisión', 'duplicate': 'duplicar', 'view': 'ver', 'edit': 'editar',
    'failed to load curricula': 'no se pudieron cargar tus currículums. Vuelve a intentarlo',
    beginner: 'principiante', 'advanced beginner': 'principiante avanzado', intermediate: 'intermedio', advanced: 'avanzado', expert: 'experto',
    'copy sections from a curriculum': 'copiar secciones de un currículum', 'keep current profile sections': 'mantener las secciones actuales del perfil', 'copied sections stay independent of later curriculum changes': 'las secciones copiadas son independientes de los cambios futuros en el currículum',
    'active curricula': 'currículums activos', 'compare plans': 'comparar planes',
    presentation: 'presentación', languages: 'idiomas', skills: 'habilidades', experience: 'experiencia', education: 'formación', certifications: 'certificaciones', portfolio: 'portafolio',
    'professional references': 'referencias profesionales', 'professional links': 'enlaces profesionales',
    'add your professional networks and external links': 'añade tus redes profesionales y enlaces externos',
    'showcase projects, work links and media': 'presenta proyectos, trabajos y contenido multimedia',
    'no professional link added yet': 'ningún enlace profesional añadido', 'no portfolio project added yet': 'ningún proyecto añadido',
    'no certifications': 'ninguna certificación añadida', 'no skills': 'ninguna habilidad añadida',
    'profile languages': 'idiomas del perfil', 'profile language': 'idioma del perfil', primary: 'principal',
    'translate your public profile independently of your curricula': 'crea versiones de tu perfil público en otros idiomas. Cada currículum tiene su propio contenido',
    'professional title': 'título profesional', 'use as primary profile language': 'usar como idioma principal del perfil',
    'profile language saved': 'versión del perfil guardada', 'could not save profile language': 'no se pudo guardar la versión del perfil',
    'edit curriculum details': 'editar datos de este currículum', 'include photo in curriculum': 'incluir foto en el currículum',
    'customize this curriculum independently of your public profile': 'personaliza este currículum de forma independiente de tu perfil público',
    'my curricula': 'mis currículums', 'duplicate curriculum': 'duplicar currículum', 'name the new curriculum': 'nombre del nuevo currículum', copy: 'copia',
    'create a new curriculum': 'crear nuevo currículum', 'create curriculum': 'crear currículum', 'curriculum language': 'idioma del currículum',
    'pending review': 'pendiente de revisión', 'new skill will be suggested for review and saved in your curriculum': 'esta habilidad se guardará en tu currículum y se sugerirá para revisar el catálogo',
    'choose a catalog skill or suggest a new one': 'elige una habilidad del catálogo o sugiere una nueva',
    'skill suggestion rejected; choose another skill': 'sugerencia no aprobada; elige otra habilidad',
    'add link': 'añadir enlace', 'add project': 'añadir proyecto', 'ready': 'listo',
  },
  en: {
    "surname": "surname",
    "your title": "professional title",
    "current country": "current country",
    "city": "city",
    "curriculum details could not be updated": "the curriculum details could not be updated. Your inputs were kept; try again",
    "curriculum details updated": "curriculum details updated",
    "link type": "link type",
    "select an option": "select an option",
    "external": "external",
    "use a secure https link": "use a secure HTTPS link",
    "edit link": "edit link",
    "delete link": "delete link",
    "opens in a new tab": "opens in a new tab",
    "select a link type and enter a valid https link": "select a link type and enter a valid HTTPS link",
    "professional link could not be saved": "the link could not be saved. Your inputs were kept; try again",
    "professional link could not be deleted": "the link could not be deleted. Try again",
    "do you really want to delete this link": "do you really want to delete this link",
    "project title": "project title",
    "project link": "project link",
    "media link": "media link",
    "use an https image or video link": "use an HTTPS image or video link",
    "display order": "display order",
    "edit project": "edit project",
    "delete project": "delete project",
    "enter a title and valid https links": "enter a title and valid HTTPS links",
    "portfolio project could not be saved": "the project could not be saved. Your inputs were kept; try again",
    "portfolio project could not be deleted": "the project could not be deleted. Try again",
    "do you really want to delete this project": "do you really want to delete this project",
    'presentation text': 'presentation text',
    'write about your experiences, your industry or your skills. also talk about your previous jobs': 'write about your experience, your industry or your skills. Also describe your previous jobs',
    'changes are saved automatically': 'changes are saved automatically',
    'saving automatically': 'saving automatically',
    'changes not saved yet': 'changes not saved yet',
    'changes saved automatically': 'changes saved automatically',
    'automatic save failed; use the save button': 'automatic save failed; use the Save button',
    'there was an error adding your presentation': 'the presentation could not be saved. Your text was kept; try again',
    'your presentation was added': 'presentation saved',
    'language proof': 'language proof', optional: 'optional',
    idiom: 'language', speaking: 'speaking', listening: 'listening', writing: 'writing', reading: 'reading',
    'add idiom': 'add language', 'edit idiom': 'edit language', 'update idiom': 'update language',
    'add skill': 'add skill', 'edit skill': 'edit skill', 'update skill': 'update skill',
    'add presentation': 'add presentation', 'edit presentation': 'edit presentation', 'update presentation': 'update presentation',
    'close': 'close',
    "curriculum editor": "curriculum editor",
    "preview curriculum": "preview curriculum",
    "curriculum preview": "curriculum preview",
    "visual template": "visual template",
    "classic template": "classic",
    "modern template": "modern",
    "minimal template": "minimal",
    "modelo europeu": "European template",
    "generating pdf": "generating PDF…",
    "export pdf": "export PDF",
    "back to editor": "back to editor",
    "pdf could not be generated": "the PDF could not be generated. Try again",
    "curriculum could not be loaded": "the curriculum could not be loaded",
    "loading curriculum": "loading curriculum",
    "no information added yet": "no information added yet",
    "finish review": "finish review",
    "this curriculum version is used in an application and is read only; duplicate it to make changes": "this curriculum version is used in an application and is read only; duplicate it to make changes",
    "no idioms": "no languages added",
    "no presentation": "no presentation added",
    "professional experiences": "professional experience",
    "professional skills": "professional skills",
    "complete professional curriculum": "complete professional curriculum",
    "current": "current",
    "open media": "open media",
    "curriculum": "curriculum",
    'could not load education options': 'could not load education options',
    'network navigation': 'network',
    'certification duration': 'duration',
    'open project': 'open project',
    'issue date': 'issue date',
    'public profile uses the sections you chose to publish': 'your public profile uses the sections you chose to publish. Later CV changes are not published automatically',
    'update published profile sections': 'update public profile sections',
    'course title': 'course title', 'education level': 'education level',
    'enter a skill name': 'enter a skill name',
    'skill name must have at least 2 characters': 'the skill name must have at least 2 characters',
    'skill name must have at most 150 characters': 'the skill name must have at most 150 characters',
    'complete the required curriculum fields': 'enter the curriculum name, language and file',
    'curriculum file could not be read': 'the file could not be read. Use a PDF with selectable text, DOCX or TXT up to 5 MB',
    'curriculum import failed': 'import failed. Your inputs were kept; check the file and try again',
    'curriculum imported as draft': 'curriculum imported as a draft. Review it before completing',
    'pdf import limit reached': 'you already have 3 imported PDFs. The initial limit is 3 PDFs',
  },
}
